module.exports = __webpack_public_path__ + "static/img/Tech_05.e3bf0490.png";